import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TranslationHistoryModal from '../modal/TranslationHistoryModal';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CorporationUsageResource({
    resourceList,
    rootCorporationInfo,
    listProvideFunction,
    isActive
}) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    // null when closed; otherwise the usage type whose history modal is open ('FILE' | 'TEXT').
    const [translationHistoryType, setTranslationHistoryType] = useState(null);

    useEffect(() => {
        if (!isActive) {
            setTranslationHistoryType(null);
        }
    }, [isActive]);

    if (Utils.isEmptyArray(resourceList)) return null;

    const isNotShowValue = label => {
        let isDeskServiceOn =
            rootCorporationInfo?.limitValue?.deskService === Constant.STATUS_SERVICE_PERMISSION.ON;
        let isKnowledgeServiceOn =
            rootCorporationInfo?.limitValue?.knowledgeService ===
            Constant.STATUS_SERVICE_PERMISSION.ON;
        let isShow = false;

        switch (label) {
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_B2C_ID_NUMBER:
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_SUPPORT_COUNTER_NUMBER:
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_PUBLIC_DESK_NUMBER:
                isShow = isDeskServiceOn;
                break;
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_KNOWLEDGE_TICKET_NUMBER:
                isShow = isKnowledgeServiceOn;
                break;
            case Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_EXTERNAL_WEB_API_CALLS_NUMBER: {
                // comment for now
                // out of scope. it will be used in next sprints.
                // const settingExternalAPI = listProvideFunction?.find(
                //     item => item.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_EXTERNAL_WEB_API
                // );
                // const isOnExternalAPI = !!settingExternalAPI?.switchCorporation;
                break;
            }
            default:
                isShow = true;
        }
        return isShow;
    };

    const isFileTranslationRow = label =>
        label === Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_FILE_TRANSLATION_USAGE;

    const isTextTranslationRow = resource =>
        resource?.type === Constant.ROOT_CORPORATION.RESOURCE_TYPE.TEXT_TRANSLATION_USAGE;

    // The history button/modal for a row uses FILE usage type by default, TEXT for the text row.
    const getResourceUsageType = resource =>
        isTextTranslationRow(resource)
            ? Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.ON_DEMAND_TEXT
            : Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.FILE;

    const orgId = rootCorporationInfo?.id || rootCorporationInfo?.corporationId;

    return (
        <>
            {resourceList?.map((resource, index) => {
                const isTextTranslationResource = isTextTranslationRow(resource);
                const isFileTranslationResource =
                    isFileTranslationRow(resource.label) || isTextTranslationResource;
                // Translation usage rows visibility is controlled by isVisible flag (set by handler)
                if (isFileTranslationResource && resource.isVisible === false) {
                    return null;
                }
                return (
                    <React.Fragment key={`${resource.label}-${index}`}>
                        {(isNotShowValue(resource.label)) && (
                            <div
                                className={`setting-item setting-item-group border-bottom${
                                    isFileTranslationResource ? ' file-translation-usage-resource' : ''
                                }`}
                            >
                                <div className="title-parent-tree">
                                    <label className={`${resource.isOverMax && 'text-over-max-warning'} setting-label-tree`}>{trI18n(resource.label)}</label>
                                    {resource.hiddenTotal ? (
                                        resource.showHistoryButton && (
                                            <button
                                                type="button"
                                                className="translation-history-btn"
                                                onClick={() =>
                                                    setTranslationHistoryType(getResourceUsageType(resource))
                                                }
                                            >
                                                {trI18n('LABEL-TRANSLATION-HISTORY')}
                                            </button>
                                        )
                                    ) : (
                                        <div className={`${resource.isOverMax && 'text-over-max-warning'}`}>
                                            {resource.value}{' '}
                                            {resource?.maxValue !== undefined && <span>/</span>}{' '}
                                            {resource.maxValue} {resource?.unit}
                                        </div>
                                    )}
                                </div>
                                {!Utils.isEmptyArray(resource.listItems) &&
                                    resource.listItems?.map(itemChild => (
                                        isNotShowValue(itemChild.label) ? (
                                            <div className="setting-children-item" key={itemChild.label}>
                                                <label className="setting-label">
                                                    {trI18n(itemChild.label)}
                                                </label>
                                                <div
                                                    className={`switch-check${
                                                        isFileTranslationResource
                                                            ? ' file-translation-usage-value'
                                                            : ''
                                                    }`}
                                                >
                                                    {itemChild?.value} {itemChild?.unit}
                                                </div>
                                            </div>
                                        ) : null
                                    ))}
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
            {translationHistoryType && (
                <TranslationHistoryModal
                    affiliationOrganization={orgId}
                    usageType={translationHistoryType}
                    titleKey={
                        translationHistoryType === Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.ON_DEMAND_TEXT
                            ? 'LABEL-TEXT-TRANSLATION-HISTORY-MODAL-TITLE'
                            : 'LABEL-TRANSLATION-HISTORY-MODAL-TITLE'
                    }
                    showPageColumn={
                        translationHistoryType !== Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.ON_DEMAND_TEXT
                    }
                    onClose={() => setTranslationHistoryType(null)}
                />
            )}
        </>
    );
}

CorporationUsageResource.propTypes = {
    resourceList: PropTypes.any,
    rootCorporationInfo: PropTypes.any,
    listProvideFunction: PropTypes.any,
    isActive: PropTypes.bool
};
